var _defs, _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _rect5, _polygon, _polygon2, _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 520.36 433.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 349.43,
    y1: 357.77,
    x2: 347.51,
    y2: 189.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 250.93,
    y1: 189.7,
    x2: 307.4,
    y2: 189.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 375.32,
    y1: 148.39,
    x2: 365.09,
    y2: 322.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 251.27,
    y1: 219.46,
    x2: 252.55,
    y2: 241.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 104.78,
    y1: 151.5,
    x2: 141.26,
    y2: 130.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 143.49,
    y1: 123.37,
    x2: 127.72,
    y2: 142.85,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 281.2,
    y1: 142.04,
    x2: 317.68,
    y2: 121.46,
    gradientTransform: "matrix(-1, 0, 0, 1, 548.7, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 319.91,
    y1: 113.91,
    x2: 304.13,
    y2: 133.38,
    gradientTransform: "matrix(-1, 0, 0, 1, 548.7, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 171.84,
    y1: 130,
    x2: 169.37,
    y2: 234.11,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 768.3,
    y1: 668.31,
    x2: 744.23,
    y2: 697.88,
    gradientTransform: "translate(-843.27 256.71) rotate(-48.02)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 208.09,
    y1: 137.27,
    x2: 217.45,
    y2: 129.76,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-17.43 -10.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.26,232.1l66.63,12.19v-61.1A28.23,28.23,0,0,0,296.66,155h0c-15.6,0-30.6,15.66-30.6,31.25Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 682.22,
    y1: 677.64,
    x2: 635.71,
    y2: 720.72,
    gradientTransform: "translate(-621.71 -30.83) rotate(-32.49)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 678.3,
    y1: 677.39,
    x2: 656.45,
    y2: 704.23,
    gradientTransform: "translate(-621.71 -30.83) rotate(-32.49)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 676.96,
    y1: 647.38,
    x2: 642.98,
    y2: 678.85,
    gradientTransform: "translate(-621.71 -30.83) rotate(-32.49)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 674.09,
    y1: 647.19,
    x2: 658.13,
    y2: 666.8,
    gradientTransform: "translate(-621.71 -30.83) rotate(-32.49)",
    xlinkHref: "#linear-gradient-5"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Inbox New Message") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M537.54,339.85a48.76,48.76,0,0,1-1.5,8.31,71,71,0,0,1-7.51,18c-19.19,33.49-56.78,52.85-94.59,60.77s-76.87,6.18-115.45,7.95c-52.12,2.36-104.1,11.11-156.22,8.24A352.33,352.33,0,0,1,89.2,431.24c-115.11,0-58.83-175.78-52.22-242.42,2.85-28.71,6.19-58.8,22.58-82.55,19.38-28.09,53.7-42.11,87.28-48.2S215,52.29,248.35,45.29C302.9,33.85,355.63,3,410.67,11.75c54,8.63,97.79,60,97.76,114.7,0,38.37-17.41,76.52-7.42,114.73C509.7,274.37,540.88,303.75,537.54,339.85Z",
    transform: "translate(-17.43 -10.2)",
    fill: "#0093ED",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,348.16a71,71,0,0,1-7.51,18c-19.19,33.49-56.78,52.85-94.59,60.77s-76.87,6.18-115.45,7.95c-52.12,2.36-104.1,11.11-156.22,8.24A352.33,352.33,0,0,1,89.2,431.24c-16-4.35-49.06-10-58.74-24.87-6.05-9.25-7-26.58-7.25-41.18,3.62.57,7.22,1.43,10.38,1.73,10.71,1,21.55,1.1,32.29,1.43q34.13,1.09,68.28,1.46,136,1.45,271.8-8.94Q471.12,355.88,536,348.16Z",
    transform: "translate(-17.43 -10.2)",
    fill: "#0093ED",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 335.97,
    y: 220.61,
    width: 25.59,
    height: 157.81,
    fill: "#0093ED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 335.97,
    y: 220.61,
    width: 25.59,
    height: 157.81,
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M439.15,182.37V244.9H263.83V182.37a32.59,32.59,0,0,1,32.63-32.59H406.52A32.62,32.62,0,0,1,439.15,182.37Z",
    transform: "translate(-17.43 -10.2)",
    fill: "#0093ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.16,145h0a28.23,28.23,0,0,1,28.23,28.23v61.1a0,0,0,0,1,0,0H250.93a0,0,0,0,1,0,0v-61.1A28.23,28.23,0,0,1,279.16,145Z",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M439.16,182.36v62.53h-108V178.7c-3.23-17.29-15.4-25.24-25.42-28.9H406.54A32.6,32.6,0,0,1,439.16,182.36Z",
    transform: "translate(-17.43 -10.2)",
    fill: "url(#linear-gradient-3)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 190.1,
    y: 225.73,
    width: 123.6,
    height: 8.97,
    rx: 4.49,
    fill: "#0093ED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 190.1,
    y: 225.73,
    width: 123.6,
    height: 8.97,
    rx: 4.49,
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.41,374.78c-14.89,2.67-29.67,6.11-44.72,7.57-9.78.95-20.57,1.44-27.65,8.24a9.24,9.24,0,0,0-3.16,5.62c-.4,4.71,4.51,8,8.91,9.72,12.82,5.07,26.76,6.52,40.53,7.4,22.42,1.42,44.9,1.45,67.37,1.47l66.93.06c19.75,0,41.68-.8,55.84-14.59,2.8-2.73,5.27-6.09,5.75-10,.78-6.28-4-12.2-9.75-14.83-10-4.56-24.93-3.61-35.81-4.82q-21.22-2.34-42.61-2.59A434.59,434.59,0,0,0,298.41,374.78Z",
    transform: "translate(-17.43 -10.2)",
    fill: "#0093ED",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M392.22,191.86c-.24.8-1,3.23-1.15,4.11l-2.4,8.86a4.44,4.44,0,0,0-.16,1.19.92.92,0,0,0,1,1,4.43,4.43,0,0,0,2.52-1,9.75,9.75,0,0,0,3.23-7.54,10,10,0,0,0-4.59-8.66,14.09,14.09,0,0,0-7.14-1.68c-8.42,0-14.32,5.59-14.32,13.49,0,7.66,5.3,12.68,13.32,12.68a21.56,21.56,0,0,0,6.1-.88,17.1,17.1,0,0,0,4.47-2.11l2.43,3.51a18.76,18.76,0,0,1-5,2.31,28.72,28.72,0,0,1-8.46,1.28c-5.62,0-10-1.6-13.16-4.75a16.41,16.41,0,0,1-4.63-11.8,17.23,17.23,0,0,1,4.87-12.45c3.67-3.67,8.49-5.47,14.68-5.47,9.29,0,15.91,6,15.91,14.32a13.43,13.43,0,0,1-3.79,9.62,10.73,10.73,0,0,1-7.46,3.27,3.94,3.94,0,0,1-3.43-1.56,2.7,2.7,0,0,1-.35-1.23,6.53,6.53,0,0,1-5.35,2.51c-3.95,0-6.46-2.95-6.46-7.5,0-6.74,4.43-12.33,9.73-12.33,2.23,0,3.35.56,4.43,2.24l.4-1.4ZM384,203.71a14.9,14.9,0,0,0,1.59-6.14c0-1.64-.92-2.75-2.31-2.75s-2.91,1-3.91,2.87a13.79,13.79,0,0,0-1.6,6c0,2.11.8,3.23,2.32,3.23S383,205.74,384,203.71Z",
    transform: "translate(-17.43 -10.2)",
    fill: "#0093ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.49,145.53c-.24-4.16.25-8.52-1.46-12.32a15.64,15.64,0,0,0-7.66-7.28,53.85,53.85,0,0,0-10.26-3.3A228.75,228.75,0,0,1,106.46,114c.88,6.22,6,10.88,10.71,15a9,9,0,0,0-3,1.26,3.07,3.07,0,0,0-1.32,2.81,4,4,0,0,0,1.24,2,15.14,15.14,0,0,0,7.14,4l-7.33,3a1.66,1.66,0,0,0-.88.62c-.32.57.11,1.26.58,1.72,3.52,3.44,9.15,3.08,14,2.49a18.21,18.21,0,0,0-6.19,4.82,1.08,1.08,0,0,0-.34.88c.11.39.58.52,1,.58a22.53,22.53,0,0,0,12.64-1.89,8.57,8.57,0,0,0-2.62,3.48,1.05,1.05,0,0,0,0,1,1.09,1.09,0,0,0,.74.29,13.89,13.89,0,0,0,9.85-2.84c.12,2.52,2.26,4.58,4.65,5.4a19,19,0,0,0,7.49.49c5-.35,2-3.23.29-5.36A14.64,14.64,0,0,1,152.49,145.53Z",
    transform: "translate(-17.43 -10.2)",
    fill: "#0093ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.49,145.53c-.24-4.16.25-8.52-1.46-12.32a15.64,15.64,0,0,0-7.66-7.28,53.85,53.85,0,0,0-10.26-3.3A228.75,228.75,0,0,1,106.46,114c.88,6.22,6,10.88,10.71,15a9,9,0,0,0-3,1.26,3.07,3.07,0,0,0-1.32,2.81,4,4,0,0,0,1.24,2,15.14,15.14,0,0,0,7.14,4l-7.33,3a1.66,1.66,0,0,0-.88.62c-.32.57.11,1.26.58,1.72,3.52,3.44,9.15,3.08,14,2.49a18.21,18.21,0,0,0-6.19,4.82,1.08,1.08,0,0,0-.34.88c.11.39.58.52,1,.58a22.53,22.53,0,0,0,12.64-1.89,8.57,8.57,0,0,0-2.62,3.48,1.05,1.05,0,0,0,0,1,1.09,1.09,0,0,0,.74.29,13.89,13.89,0,0,0,9.85-2.84c.12,2.52,2.26,4.58,4.65,5.4a19,19,0,0,0,7.49.49c5-.35,2-3.23.29-5.36A14.64,14.64,0,0,1,152.49,145.53Z",
    transform: "translate(-17.43 -10.2)",
    fill: "url(#linear-gradient-5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.05,145.21c-.16-2.84.17-5.82-1-8.41a10.67,10.67,0,0,0-5.24-5,37.23,37.23,0,0,0-7-2.26,154.65,154.65,0,0,1-18.21-5.9c.59,4.25,4.06,7.43,7.31,10.23a6.17,6.17,0,0,0-2,.87,2.08,2.08,0,0,0-.9,1.92,2.68,2.68,0,0,0,.84,1.36,10.47,10.47,0,0,0,4.88,2.74l-5,2.06a1.14,1.14,0,0,0-.61.43c-.22.39.08.86.4,1.17,2.41,2.36,6.26,2.11,9.6,1.7a12.51,12.51,0,0,0-4.23,3.3.72.72,0,0,0-.23.6c.07.26.39.35.66.39a15.28,15.28,0,0,0,8.64-1.29,5.91,5.91,0,0,0-1.79,2.38c-.09.23-.17.52,0,.71a.69.69,0,0,0,.5.19,9.5,9.5,0,0,0,6.74-1.93,4.41,4.41,0,0,0,3.17,3.68,13.14,13.14,0,0,0,5.12.34c3.45-.24,1.35-2.21.2-3.67A10,10,0,0,1,145.05,145.21Z",
    transform: "translate(-17.43 -10.2)",
    fill: "#0093ED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.05,145.21c-.16-2.84.17-5.82-1-8.41a10.67,10.67,0,0,0-5.24-5,37.23,37.23,0,0,0-7-2.26,154.65,154.65,0,0,1-18.21-5.9c.59,4.25,4.06,7.43,7.31,10.23a6.17,6.17,0,0,0-2,.87,2.08,2.08,0,0,0-.9,1.92,2.68,2.68,0,0,0,.84,1.36,10.47,10.47,0,0,0,4.88,2.74l-5,2.06a1.14,1.14,0,0,0-.61.43c-.22.39.08.86.4,1.17,2.41,2.36,6.26,2.11,9.6,1.7a12.51,12.51,0,0,0-4.23,3.3.72.72,0,0,0-.23.6c.07.26.39.35.66.39a15.28,15.28,0,0,0,8.64-1.29,5.91,5.91,0,0,0-1.79,2.38c-.09.23-.17.52,0,.71a.69.69,0,0,0,.5.19,9.5,9.5,0,0,0,6.74-1.93,4.41,4.41,0,0,0,3.17,3.68,13.14,13.14,0,0,0,5.12.34c3.45-.24,1.35-2.21.2-3.67A10,10,0,0,1,145.05,145.21Z",
    transform: "translate(-17.43 -10.2)",
    fill: "url(#linear-gradient-6)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.8,136.07c.24-4.16-.25-8.52,1.45-12.32a15.64,15.64,0,0,1,7.67-7.29,54.33,54.33,0,0,1,10.26-3.3,228.54,228.54,0,0,0,26.64-8.63c-.87,6.21-5.95,10.87-10.7,15a8.87,8.87,0,0,1,3,1.27,3,3,0,0,1,1.32,2.8,3.87,3.87,0,0,1-1.23,2,15.22,15.22,0,0,1-7.14,4l7.32,3a1.66,1.66,0,0,1,.89.63c.32.57-.12,1.26-.58,1.71-3.53,3.45-9.16,3.09-14.05,2.49a18.36,18.36,0,0,1,6.19,4.83,1,1,0,0,1,.33.88c-.1.38-.57.51-1,.57a22.55,22.55,0,0,1-12.64-1.88,8.53,8.53,0,0,1,2.63,3.48,1,1,0,0,1,0,1,1,1,0,0,1-.74.28,13.91,13.91,0,0,1-9.85-2.83c-.11,2.52-2.26,4.58-4.64,5.4a19.22,19.22,0,0,1-7.49.48c-5.06-.34-2-3.23-.29-5.36C219,142,219.63,138.91,219.8,136.07Z",
    transform: "translate(-17.43 -10.2)",
    fill: "#0093ED"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M219.8,136.07c.24-4.16-.25-8.52,1.45-12.32a15.64,15.64,0,0,1,7.67-7.29,54.33,54.33,0,0,1,10.26-3.3,228.54,228.54,0,0,0,26.64-8.63c-.87,6.21-5.95,10.87-10.7,15a8.87,8.87,0,0,1,3,1.27,3,3,0,0,1,1.32,2.8,3.87,3.87,0,0,1-1.23,2,15.22,15.22,0,0,1-7.14,4l7.32,3a1.66,1.66,0,0,1,.89.63c.32.57-.12,1.26-.58,1.71-3.53,3.45-9.16,3.09-14.05,2.49a18.36,18.36,0,0,1,6.19,4.83,1,1,0,0,1,.33.88c-.1.38-.57.51-1,.57a22.55,22.55,0,0,1-12.64-1.88,8.53,8.53,0,0,1,2.63,3.48,1,1,0,0,1,0,1,1,1,0,0,1-.74.28,13.91,13.91,0,0,1-9.85-2.83c-.11,2.52-2.26,4.58-4.64,5.4a19.22,19.22,0,0,1-7.49.48c-5.06-.34-2-3.23-.29-5.36C219,142,219.63,138.91,219.8,136.07Z",
    transform: "translate(-17.43 -10.2)",
    fill: "url(#linear-gradient-7)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M227.24,135.75c.16-2.84-.17-5.82,1-8.42a10.72,10.72,0,0,1,5.24-5,37,37,0,0,1,7-2.25,157.2,157.2,0,0,0,18.21-5.91c-.6,4.25-4.07,7.44-7.32,10.24a6.06,6.06,0,0,1,2,.86,2.1,2.1,0,0,1,.91,1.92,2.72,2.72,0,0,1-.85,1.37,10.35,10.35,0,0,1-4.88,2.73l5,2.07a1.09,1.09,0,0,1,.6.42c.22.39-.08.87-.39,1.18-2.41,2.35-6.26,2.1-9.6,1.7a12.35,12.35,0,0,1,4.22,3.3.68.68,0,0,1,.23.6c-.07.26-.39.35-.66.39a15.39,15.39,0,0,1-8.64-1.29,5.87,5.87,0,0,1,1.8,2.38.73.73,0,0,1,0,.7.71.71,0,0,1-.51.2,9.53,9.53,0,0,1-6.73-1.94,4.44,4.44,0,0,1-3.17,3.69,13,13,0,0,1-5.13.33c-3.45-.23-1.34-2.21-.19-3.66A10.12,10.12,0,0,0,227.24,135.75Z",
    transform: "translate(-17.43 -10.2)",
    fill: "#0093ED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M227.24,135.75c.16-2.84-.17-5.82,1-8.42a10.72,10.72,0,0,1,5.24-5,37,37,0,0,1,7-2.25,157.2,157.2,0,0,0,18.21-5.91c-.6,4.25-4.07,7.44-7.32,10.24a6.06,6.06,0,0,1,2,.86,2.1,2.1,0,0,1,.91,1.92,2.72,2.72,0,0,1-.85,1.37,10.35,10.35,0,0,1-4.88,2.73l5,2.07a1.09,1.09,0,0,1,.6.42c.22.39-.08.87-.39,1.18-2.41,2.35-6.26,2.1-9.6,1.7a12.35,12.35,0,0,1,4.22,3.3.68.68,0,0,1,.23.6c-.07.26-.39.35-.66.39a15.39,15.39,0,0,1-8.64-1.29,5.87,5.87,0,0,1,1.8,2.38.73.73,0,0,1,0,.7.71.71,0,0,1-.51.2,9.53,9.53,0,0,1-6.73-1.94,4.44,4.44,0,0,1-3.17,3.69,13,13,0,0,1-5.13.33c-3.45-.23-1.34-2.21-.19-3.66A10.12,10.12,0,0,0,227.24,135.75Z",
    transform: "translate(-17.43 -10.2)",
    fill: "url(#linear-gradient-8)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 150.8,
    y: 151.13,
    width: 75.31,
    height: 46.42,
    transform: "translate(-34.38 10.14) rotate(-5.91)",
    fill: "#0093ED"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "210.87 183.35 135.96 191.1 131.18 144.93 207.46 136.44 210.87 183.35",
    fill: "url(#linear-gradient-9)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.18 144.93 172.71 179.18 206.44 137.83 131.18 144.93",
    fill: "url(#linear-gradient-10)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 208.4,
    cy: 136.71,
    r: 10.49,
    fill: "#0093ED"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.61,
    cy: 136.85,
    r: 10.49,
    fill: "url(#linear-gradient-11)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 193.86,
    width: 68.36,
    height: 42.14,
    transform: "translate(23.11 -61.87) rotate(9.62)",
    fill: "#0093ED"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.93 231.22 272.52 219.79 279.57 178.25 348.35 189.36 339.93 231.22",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.57 178.25 307.56 218.3 347.12 190.33 279.57 178.25",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.66,
    y: 168.64,
    width: 49.94,
    height: 30.79,
    transform: "translate(17.68 -59.21) rotate(9.62)",
    fill: "#0093ED"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.25 193.18 264.01 184.83 269.16 154.48 319.4 162.6 313.25 193.18",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.16 154.48 289.61 183.74 318.5 163.31 269.16 154.48",
    fill: "url(#linear-gradient-15)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email_sent.5c876095cb7436f29e94cfec336efb36.svg";
export { ForwardRef as ReactComponent };